import React from "react";
import { BadgeCheck } from "lucide-react";
import { useApp } from "@/context/AppContext";

export const ORGANIC_CATS = ["organic_pesticides", "organic_produce", "residue_free"];

export const OrganicBadge = ({ category, size = "sm" }) => {
  const { lang } = useApp();
  if (!ORGANIC_CATS.includes(category)) return null;
  const residue = category === "residue_free";
  const label = residue
    ? (lang === "hi" ? "अवशेष-मुक्त प्रमाणित" : "Residue-Free Certified")
    : (lang === "hi" ? "100% जैविक" : "100% Organic");
  const cls = size === "lg" ? "text-xs px-3 py-1.5" : "text-[10px] px-2 py-1";
  return (
    <span
      data-testid={`organic-badge-${category}`}
      className={`inline-flex items-center gap-1 rounded-full bg-[#15803D] text-white font-semibold uppercase tracking-wider shadow-sm ring-2 ring-white ${cls}`}
    >
      <BadgeCheck className={size === "lg" ? "w-4 h-4" : "w-3 h-3"} />
      {label}
    </span>
  );
};
